import React from 'react'
import { useServerCurrency } from '../../lib/hooks/useServerCurrency'
import { CURRENCIES } from '../../lib/constants'
import { useTranslation } from 'next-i18next'

type CurrencySelectorProps = {
  className?: string
  showDetectOption?: boolean
}

// Currency symbol mapping
const CURRENCY_SYMBOLS: Record<string, string> = {
  EUR: '€',
  USD: '$',
  GBP: '£',
}

/**
 * A component that allows users to select their preferred currency.
 * Uses the currency_override cookie to override the geo-based currency detection.
 */
export const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  className = '',
  showDetectOption = true,
}) => {
  // Use our new hook that handles both server and client data
  const { setCurrencyOverride, currencyOverride } = useServerCurrency()
  const { t } = useTranslation('common')

  const handleCurrencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value as (typeof CURRENCIES)[number] | 'detect'
    setCurrencyOverride(value)
  }

  return (
    <div className={`currency-selector ${className}`}>
      <select
        value={currencyOverride || 'detect'}
        onChange={handleCurrencyChange}
        className="px-2 py-1 border border-gray-300 rounded"
        aria-label="Select currency"
      >
        {showDetectOption && <option value="detect">{t('detect')}</option>}
        {CURRENCIES.map((curr) => (
          <option key={curr} value={curr}>
            {curr} - {CURRENCY_SYMBOLS[curr]}
          </option>
        ))}
      </select>
    </div>
  )
}
